import React, { FC } from 'react';
import TotalAmountBadges from '../common/TotalAmountBadges';
import TotalDropDown from '../../shop/selectionlists/TotalDropDown';
import SubNavigationLayout from './SubNavigationLayout';

import './ReserveDetailNavigation.scss';
import { useParams } from 'react-router';
import { useReserveReportSummary } from '../../shop/reserve/api/reserve-list/useReserveReportSummary';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { parseLoanFormat } from '../../../models/LoanFormat';
import {
    LOANFORMAT_EAUDIOBOOK_OBJECT,
    LOANFORMAT_EAUDIOBOOKS,
    LOANFORMAT_EBOOK_OBJECT,
    LOANFORMAT_EBOOKS
} from '../loanFormat/constants';

type Props = {
    readonly isSticky: boolean;
};

const ReserveDetailNavigation: FC<Props> = ({ isSticky }) => {
    const { reserveListId = '' } = useParams<'reserveListId'>();
    const { data: meta } = useReserveReportSummary(reserveListId);

    if (!meta) {
        return null;
    }

    const { summary, date, loanFormatSettings = {} } = meta;
    const { [LOANFORMAT_EBOOKS]: eBookSettings, [LOANFORMAT_EAUDIOBOOKS]: eAudiobookSettings } = loanFormatSettings;

    const reportHasEbooks = !!eBookSettings;
    const reportHasEaudiobooks = !!eAudiobookSettings;

    const reserveLoanFormat =
        reportHasEbooks && !reportHasEaudiobooks
            ? LOANFORMAT_EBOOK_OBJECT
            : !reportHasEbooks && reportHasEaudiobooks
            ? LOANFORMAT_EAUDIOBOOK_OBJECT
            : null;
    const mappedReserveLoanFormat = parseLoanFormat(reserveLoanFormat?.name)?.toLowerCase();

    // TODO [i18n] css Total amount is not visible
    return (
        <SubNavigationLayout
            className="reserve-detail-nav"
            isSticky={isSticky}
            left={
                <span className="reserve-detail-nav-title">
                    {mappedReserveLoanFormat ? (
                        <Trans
                            i18nKey="reserveReports.reserveReport.viewReport.reportDate"
                            components={[<i className="bolinda-icons" />]}
                            values={{
                                icon: 'book',
                                loanFormat: t(`loanFormat.plain.${mappedReserveLoanFormat}`, {
                                    count: 10
                                }),
                                date: t('dateFormat.date', {
                                    val: new Date(date ?? 0)
                                })
                            }}
                        />
                    ) : (
                        t('reserveReports.reserveReport.viewReport.reportDateWithoutLoanFormat', {
                            date: t('dateFormat.date', {
                                val: new Date(date ?? 0)
                            })
                        })
                    )}
                </span>
            }
            right={
                <div className="reserve-detail-nav-amounts">
                    <TotalAmountBadges {...summary} className="display-flex" />
                    <TotalDropDown
                        summary={summary}
                        textTotalLine={t('reserveReports.reserveReport.viewReport.orderTotal')}
                    />
                </div>
            }
        />
    );
};

export default ReserveDetailNavigation;
